import React from "react";

interface SearchQueryIconProps {
  size?: number | string;
  className?: string;
  onClick?: () => void;
  color?: string
}

const SingleColumnIcon: React.FC<SearchQueryIconProps> = ({
  size = 18,
  className,
  onClick,
  color = '#0556CB',
}) => (
  <svg width="93" height="33" viewBox="0 0 99 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12.6934" width="73" height="6" rx="1" fill={color} fillOpacity="0.3" />
    <rect y="11.3101" width="98.3877" height="2" rx="1" fill={color} fillOpacity="0.1" />
    <rect y="15.3101" width="98.3877" height="2" rx="1" fill={color} fillOpacity="0.1" />
    <rect y="19.3101" width="98.3877" height="2" rx="1" fill={color} fillOpacity="0.1" />
    <rect x="28.6934" y="26.6201" width="41" height="6" rx="1" fill={color} fillOpacity="0.3" />
  </svg>


);

export default SingleColumnIcon;
